var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogposthighlighted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_25116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 26.2505H41.75",
    stroke: "#98249A",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 33.7505H41.75",
    stroke: "#0A70B8",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.0005C11.75 14.5032 11.9475 14.0263 12.2992 13.6747C12.6508 13.323 13.1277 13.1255 13.625 13.1255H32.375H51.125C51.6223 13.1255 52.0992 13.323 52.4508 13.6747C52.8025 14.0263 53 14.5032 53 15.0005V43.1255C53 44.1201 52.6049 45.0739 51.9017 45.7771C51.1984 46.4804 50.2446 46.8755 49.25 46.8755H28.625",
    stroke: "#26BC96",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 46.8755C7.00544 46.8755 6.05161 46.4804 5.34835 45.7771C4.64509 45.0739 4.25 44.1201 4.25 43.1255V20.6255",
    stroke: "#A9D726",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 46.8755H8C8.99456 46.8755 9.94839 46.4804 10.6517 45.7771C11.3549 45.0739 11.75 44.1201 11.75 43.1255V29.063V22.0317",
    stroke: "#FBBF00",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1090_25116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.125 11.2505H13.625C12.6304 11.2505 11.6766 11.6456 10.9733 12.3488C10.2701 13.0521 9.875 14.0059 9.875 15.0005V43.1255C9.875 43.6228 9.67746 44.0997 9.32582 44.4513C8.97419 44.8029 8.49728 45.0005 8 45.0005C7.50272 45.0005 7.02581 44.8029 6.67417 44.4513C6.32254 44.0997 6.125 43.6228 6.125 43.1255V20.6255C6.125 20.1282 5.92746 19.6513 5.57583 19.2997C5.22419 18.948 4.74728 18.7505 4.25 18.7505C3.75272 18.7505 3.27581 18.948 2.92417 19.2997C2.57254 19.6513 2.375 20.1282 2.375 20.6255V43.1513C2.38182 44.6386 2.97746 46.0628 4.03161 47.1121C5.08577 48.1614 6.51261 48.7505 8 48.7505H49.25C50.7418 48.7505 52.1726 48.1579 53.2275 47.103C54.2824 46.0481 54.875 44.6173 54.875 43.1255V15.0005C54.875 14.0059 54.4799 13.0521 53.7766 12.3488C53.0734 11.6456 52.1196 11.2505 51.125 11.2505ZM41.75 35.6255H23C22.5027 35.6255 22.0258 35.4279 21.6742 35.0763C21.3225 34.7247 21.125 34.2478 21.125 33.7505C21.125 33.2532 21.3225 32.7763 21.6742 32.4247C22.0258 32.073 22.5027 31.8755 23 31.8755H41.75C42.2473 31.8755 42.7242 32.073 43.0758 32.4247C43.4275 32.7763 43.625 33.2532 43.625 33.7505C43.625 34.2478 43.4275 34.7247 43.0758 35.0763C42.7242 35.4279 42.2473 35.6255 41.75 35.6255ZM41.75 28.1255H23C22.5027 28.1255 22.0258 27.9279 21.6742 27.5763C21.3225 27.2247 21.125 26.7478 21.125 26.2505C21.125 25.7532 21.3225 25.2763 21.6742 24.9247C22.0258 24.573 22.5027 24.3755 23 24.3755H41.75C42.2473 24.3755 42.7242 24.573 43.0758 24.9247C43.4275 25.2763 43.625 25.7532 43.625 26.2505C43.625 26.7478 43.4275 27.2247 43.0758 27.5763C42.7242 27.9279 42.2473 28.1255 41.75 28.1255Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_25116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1090_25116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(30.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogposthighlighted);
export default __webpack_public_path__ + "static/media/blogposthighlighted.23060794d827869b4e40b8cfc3e04296.svg";
export { ForwardRef as ReactComponent };